function distribuicaoGroupKey(item) {
    if (item.tipo === "M" || item.tipo === "P") {
        return item.tipo;
    }
    return "".concat(item.tipo, ":").concat(item.tipoEspecialidade);
}
/**
 * Um item por grupo (tipo M/P ou tipo+especialidade), com maior dataVinculacao (AAAAMMDD).
 * Ordem dos grupos = primeira ocorrência da chave no array original.
 */
export function pickLatestDistribuicaoEquitativaPerTipo(items) {
    var firstIndexByKey = new Map();
    var winnerByKey = new Map();
    items.forEach(function (item, index) {
        var key = distribuicaoGroupKey(item);
        if (!firstIndexByKey.has(key)) {
            firstIndexByKey.set(key, index);
        }
        var existing = winnerByKey.get(key);
        if (!existing || item.dataVinculacao > existing.dataVinculacao) {
            winnerByKey.set(key, item);
        }
    });
    return Array.from(winnerByKey.entries())
        .sort(function (a, b) { return firstIndexByKey.get(a[0]) - firstIndexByKey.get(b[0]); })
        .map(function (_a) {
        var item = _a[1];
        return item;
    });
}
export function findLatestDistribuicaoEquitativaByTipo(items, type) {
    return pickLatestDistribuicaoEquitativaPerTipo(items).find(function (item) { return item.tipo === type; });
}
